import { useState, type ReactNode } from "react";

// A dialog that exists only while it is open or leaving — the donor's
// `{(open || closing) && <Dialog … />}` (`LineMoreActions.tsx:62-100,279-302`,
// the Editor's row menu), which unmounts each dialog after its close so every
// opening is a fresh form seeded from its row, a fresh write, and a failure's
// snackbar gone with it (#807 E19, E27). The donor waits a flat 500ms; this
// waits for the paper's own exit, handed to the dialog as `onExited`.

export function MountedWhileOpen({
  open,
  children,
}: {
  open: boolean;
  /** The dialog, handed the exit that unmounts it. */
  children: (onExited: () => void) => ReactNode;
}) {
  const [mounted, setMounted] = useState(open);
  if (open && !mounted) setMounted(true);
  if (!mounted) return null;
  return children(() => setMounted(false));
}
